<div class="form-group row col-md-12" *ngIf="role == 'admin'">
  <label class="col-5 col-form-label required_label">{{
    "Chọn đối tác" | translate
  }}</label>
  <div class="col-12">
    <select
      class="form-select"
      aria-label="Default select example"
      class="form-control"
      [(ngModel)]="partnerOption"
      (change)="getDataBranch()"
    >
      <option value="{{ item.value }}" *ngFor="let item of partnerOptions">
        {{ item.label }}
      </option>
    </select>
  </div>
</div>
<div class="mb-dashboard">
  <div class="row d-flex">
    <div class="col-md-6 mb-2">
      <div class="card-custom">
        <div class="row">
          <div class="card-body-big px-4 py-2 col custom-border-right">
            <div class="row">
              <div class="col-6 counter-card-icon">
                <img
                  class="img-fluid"
                  width=""
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/2b6cb253969f388483dd9e4077305acc4906ef103d154a5200dd65cdb85bb09a?placeholderIfAbsent=true&apiKey=d4ca2351fe0547ebb2bb09bab66a16f8"
                  alt=""
                />
              </div>
              <div class="d-flex align-items-start mt-2 justify-content-start">
                <div class="counter-card-text">
                  <span class="display-4">Khách hàng</span>

                  <h3>{{ dataStatistics?.totalCustomers }}</h3>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="fullname != 'mb_quanlychinhanh'" class="card-body-big px-3 py-2 col custom-border-right">
            <div class="row">
              <div class="col-6 counter-card-icon">
                <img
                  class="img-fluid"
                  width=""
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/6de68c8929aac998a80e3bebcf66677b37cb84282f8ed08ef99330ccf2593ae6?placeholderIfAbsent=true&apiKey=d4ca2351fe0547ebb2bb09bab66a16f8"
                />
              </div>
              <div class="d-flex align-items-start mt-2 justify-content-start">
                <div class="counter-card-text">
                  <span class="display-4">Cửa hàng</span>

                  <h3>{{ dataStatistics?.totalWorkspaces }}</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body-big px-3 py-2 col">
            <div class="row">
              <div class="col-6 counter-card-icon">
                <img
                  class="img-fluid"
                  width=""
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/e1de7900d18323f5683ed0cecfc72f433bc5bd5acb176dba5aca7f8ffd7f2799?placeholderIfAbsent=true&apiKey=d4ca2351fe0547ebb2bb09bab66a16f8"
                  alt=""
                />
              </div>
              <div class="d-flex align-items-start mt-2 justify-content-start">
                <div class="counter-card-text">
                  <span class="display-4">TB đơn hàng/KH</span>

                  <h3>{{ dataStatistics?.averageOrder }}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 mb-2">
      <div class="card-custom">
        <div class="row">
          <div class="card-body-big px-4 py-2 col-4 custom-border-right">
            <div class="row">
              <div class="col-6 counter-card-icon">
                <img
                  class="img-fluid"
                  width=""
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/1c5a4947a67701adf91d6c5551922e3bf1227efae35863949ac5681a2f49a1f1?placeholderIfAbsent=true&apiKey=d4ca2351fe0547ebb2bb09bab66a16f8"
                  alt=""
                />
              </div>
              <div class="d-flex align-items-start mt-2 justify-content-start">
                <div class="counter-card-text">
                  <span class="display-4">Đơn hàng</span>

                  <h3>{{ dataStatistics?.totalOrders }}</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body-big px-3 py-2 col-4 custom-border-right">
            <div class="row">
              <div class="col-6 counter-card-icon">
                <img
                  class="img-fluid"
                  width=""
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/ad11acc746260ea376ebfa37561d538ced9e46703f91a245d45e1b398089bc7c?placeholderIfAbsent=true&apiKey=d4ca2351fe0547ebb2bb09bab66a16f8"
                />
              </div>
              <div class="d-flex align-items-start mt-2 justify-content-start">
                <div class="counter-card-text">
                  <span class="display-4">Đơn online</span>

                  <h3>{{ dataStatistics?.totalOrderOnline }}</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body-big px-3 py-2 col-4">
            <div class="row">
              <div class="col-6 counter-card-icon">
                <img
                  class="img-fluid"
                  width=""
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/7283beeabe5a9cf9ff8bee60c6e50e6d39fdce14250eb9f835ce180a010710c1?placeholderIfAbsent=true&apiKey=d4ca2351fe0547ebb2bb09bab66a16f8"
                  alt=""
                />
              </div>
              <div class="d-flex align-items-start mt-2 justify-content-start">
                <div class="counter-card-text">
                  <span class="display-4">Đơn trực tiếp</span>

                  <h3>{{ dataStatistics?.totalOrderDirect }}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 mb-2">
      <div class="card-custom">
        <div class="row">
          <div class="card-body-big px-4 py-2 col-4 custom-border-right">
            <div class="row">
              <div class="col-6 counter-card-icon">
                <img
                  class="img-fluid"
                  width=""
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/e1de7900d18323f5683ed0cecfc72f433bc5bd5acb176dba5aca7f8ffd7f2799?placeholderIfAbsent=true&apiKey=d4ca2351fe0547ebb2bb09bab66a16f8"
                  alt=""
                />
              </div>
              <div class="d-flex align-items-start mt-2 justify-content-start">
                <div class="counter-card-text">
                  <span class="display-4">Thiết bị</span>

                  <h3>{{ dataStatistics?.totalDeviceSold }}</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body-big px-3 py-2 col-4 custom-border-right">
            <div class="row">
              <div class="col-6 counter-card-icon">
                <img
                  class="img-fluid"
                  width=""
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/ad11acc746260ea376ebfa37561d538ced9e46703f91a245d45e1b398089bc7c?placeholderIfAbsent=true&apiKey=d4ca2351fe0547ebb2bb09bab66a16f8"
                />
              </div>
              <div class="d-flex align-items-start mt-2 justify-content-start">
                <div class="counter-card-text">
                  <span class="display-4">Loa 4G</span>

                  <h3>{{ dataStatistics?.totalDevice4GSold }}</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body-big px-3 py-2 col-4">
            <div class="row">
              <div class="col-6 counter-card-icon">
                <img
                  class="img-fluid"
                  width=""
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/992b389fdb37a15384bb64d9b965dc1c73724e0864425b943239b79c7bb6e40e?placeholderIfAbsent=true&apiKey=d4ca2351fe0547ebb2bb09bab66a16f8"
                  alt=""
                />
              </div>
              <div class="d-flex align-items-start mt-2 justify-content-start">
                <div class="counter-card-text">
                  <span class="display-4">Loa Wifi</span>

                  <h3>{{ dataStatistics?.totalDeviceWifiSold }}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 mb-2">
      <div class="card-custom">
        <div class="row">
          <div class="card-body-big px-4 py-2 col-6 custom-border-right">
            <div class="row">
              <div class="col-6 counter-card-icon">
                <img
                  class="img-fluid"
                  width=""
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/6526a6ec70b7dc297465c36bc82054f8a126a5150c5390197ff6f6ebfa4bb0fd?placeholderIfAbsent=true&apiKey=d4ca2351fe0547ebb2bb09bab66a16f8"
                />
              </div>
              <div class="d-flex align-items-start mt-2 justify-content-start">
                <div class="counter-card-text">
                  <span class="display-4">BQ doanh số GD/cửa hàng</span>
                  <h3>
                    {{ dataTotal?.averageAmount | number : "1.0-0" }}
                    <span> VND /ngày</span>
                  </h3>
                </div>
              </div>
            </div>
            <span class="month-label">{{ currentMonth }}</span>
          </div>

          <div class="card-body-big px-3 py-2 col-6">
            <div class="row">
              <div class="col-6 counter-card-icon">
                <img
                  class="img-fluid"
                  width=""
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/81ebc8c8b941a145615296a0eba8eed5537ca96e0e5f80cb5660565f29df51fd?placeholderIfAbsent=true&apiKey=d4ca2351fe0547ebb2bb09bab66a16f8"
                  alt=""
                />
              </div>
              <div class="d-flex align-items-start mt-2 justify-content-start">
                <div class="counter-card-text">
                  <span class="display-4">BQ số giao dịch/cửa hàng</span>
                  <h3>
                    {{ dataTotal?.averageTotal }} <span>giao dịch/ngày</span>
                  </h3>
                </div>
              </div>
            </div>
            <span class="month-label">{{ currentMonth }}</span>
          </div>
        </div>
      </div>
    </div>

    <div [ngClass]="{ 'col-md-12': fullname === 'mb_quanlychinhanh', 'col-md-5': fullname !== 'mb_quanlychinhanh' }" class="mb-2">
      <div class="card-custom-chart">
        <div class="row p-4 card-body-big">
          <h2 clas="chart-title">Biểu đồ gói dịch vụ</h2>
          <div id="chart" class="pt-2">
            <apx-chart
              [series]="chartOptionsDonut?.series"
              [chart]="chartOptionsDonut?.chart"
              [labels]="chartOptionsDonut?.labels"
              [colors]="chartOptionsDonut?.colors"
              [legend]="chartOptionsDonut?.legend"
              [dataLabels]="chartOptionsDonut?.dataLabels"
              [tooltip]="chartOptionsDonut?.tooltip"
              [plotOptions]="chartOptionsDonut?.plotOptions"
            >
            </apx-chart>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-7 mb-2" *ngIf="fullname !== 'mb_quanlychinhanh'">
      <div class="card-custom-chart">
        <div class="row p-4 card-body-big">
          <div class="d-md-flex justify-content-between align-items-center">
            <h2 clas="chart-title">Tỷ lệ cửa hàng inactive</h2>
            <div class="btn-group rounded-sm border-secondary col-md-6">
              <button
                *ngFor="let range of timeRangesInactive"
                (click)="updateChart('chartInactive', range.value)"
                [class.active]="selectedRange['chartInactive'] === range.value"
                class="btn btn-outline-primary btn-sm"
              >
                {{ range.label }}
              </button>
            </div>
          </div>

          <div *ngIf="loadingState['chartInactive']" class="loading-container">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div id="chart" class="pt-2" *ngIf="!loadingState['chartInactive']">
            <apx-chart
              [series]="chartInactive?.series"
              [chart]="chartInactive?.chart"
              [xaxis]="chartInactive?.xaxis"
              [yaxis]="chartInactive?.yaxis"
              [stroke]="chartInactive?.stroke"
              [fill]="chartInactive?.fill"
              [dataLabels]="chartInactive?.dataLabels"
              [tooltip]="chartInactive?.tooltip"
              [markers]="chartInactive?.markers"
            ></apx-chart>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-2">
      <app-new-open-chart
        [chartOptions]="chartOptionsOpenReport"
        [role]="role"
        [loading]="loadingState.chartOpenReport"
        (optionSelected)="onOptionSelected($event)"
      ></app-new-open-chart>
    </div>
    <div class="mb-2">
      <app-monthly-chart
        [chartOptions]="chartOptionsMonthlyReport"
        [loading]="loadingState.chartMonthlyReport"
        (optionSelected)="onOptionMonthlySelected($event)"
      ></app-monthly-chart>
    </div>
    <div class="mb-2">
      <app-new-open-branch-chart
        [chartOptionsList]="chartOptionsOpenBranchReport"
        [loading]="loadingState.chartOpenBranchReport"
        (optionSelected)="onOptionOpenBranchSelected($event)"
      ></app-new-open-branch-chart>
    </div>
    <div class="col-md-12 mb-2">
      <div class="card-custom">
        <div class="row p-4 card-body-big">
          <h2 clas="chart-title">Báo cáo theo giao dịch</h2>
          <div class="btn-group rounded-sm border-secondary col-md-2">
            <button
              class="btn btn-outline-primary btn-sm"
              (click)="updateChart('chartQR', 'day')"
              [class.active]="selectedRange['chartQR'] === 'day'"
            >
              Ngày
            </button>
            <button
              class="btn btn-outline-primary btn-sm"
              (click)="updateChart('chartQR', 'month')"
              [class.active]="selectedRange['chartQR'] === 'month'"
            >
              Tháng
            </button>
          </div>

          <div *ngIf="loadingState['chartQR']" class="loading-container">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div class="col-md-12" class="chart-container" id="chart" *ngIf="!loadingState['chartQR']">
            <apx-chart
              [series]="chartOptionsQR?.series"
              [chart]="chartOptionsQR?.chart"
              [yaxis]="chartOptionsQR?.yaxis"
              [xaxis]="chartOptionsQR?.xaxis"
              [labels]="chartOptionsQR?.labels"
              [stroke]="chartOptionsQR?.stroke"
              [title]="chartOptionsQR?.title"
              [dataLabels]="chartOptionsQR?.dataLabels"
              [fill]="chartOptionsQR?.fill"
              [tooltip]="chartOptionsQR?.tooltip"
            ></apx-chart>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 mb-2">
      <div class="card-custom">
        <div class="row p-3 card-body-big">
          <div class="d-md-flex justify-content-between align-items-center">
            <h2
              clas="chart-title"
              *ngIf="role == 'branch_operation'; else admin"
            >
              Báo cáo loa phát triển trực tiếp
            </h2>
            <ng-template #admin>
              <h2 clas="chart-title">Báo cáo theo đơn vị kinh doanh</h2>
            </ng-template>
            <div class="btn-group rounded-sm border-secondary col-md-6">
              <button
                *ngFor="let range of timeRangesBranch"
                (click)="updateChart('chartBranch', range.value)"
                [class.active]="selectedRange['chartBranch'] === range.value"
                class="btn btn-outline-primary btn-sm"
              >
                {{ range.label }}
              </button>
            </div>
          </div>
          <div *ngIf="!totalDevice" class="mt-4 text-danger text-center">
            <h2 class="text-danger">Không có dữ liệu</h2>
          </div>
          <div *ngIf="loadingState['chartBranch']" class="loading-container">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <article
            *ngIf="!loadingState['chartBranch']"
            class="allocation-container col-md-4 pt-2"
          >
            <div class="allocation-info" *ngIf="totalDevice">
              <h3 class="allocation-title">Tổng thiết bị phân bổ</h3>
              <p class="allocation-count">{{ totalDevice }}</p>
            </div>
            <img
              *ngIf="totalDevice"
              src="https://cdn.builder.io/api/v1/image/assets/d4ca2351fe0547ebb2bb09bab66a16f8/1b966a34e99931882b3eaebb443e01db4914e2c42d9d9c9af513e053edf2a1da?placeholderIfAbsent=true"
              alt="Device allocation icon"
              class="allocation-icon"
            />
          </article>
          <div class="col-md-12 row">
            <div
              class="col-md-4 d-flex align-items-center justify-content-center"
              id="chart"
              *ngIf="!loadingState['chartBranch']"
            >
              <apx-chart
                class="d-flex align-items-center justify-content-center"
                [series]="chartOptions?.series"
                [chart]="chartOptions?.chart"
                [labels]="chartOptions?.labels"
                [responsive]="chartOptions?.responsive"
              ></apx-chart>
            </div>

            <div
              class="col-md-8"
              id="chart-container"
              *ngIf="!loadingState['chartBranch']"
            >
              <apx-chart
                [series]="stackBarChart?.series"
                [chart]="stackBarChart?.chart"
                [plotOptions]="stackBarChart?.plotOptions"
                [stroke]="stackBarChart?.stroke"
                [xaxis]="stackBarChart?.xaxis"
                [tooltip]="stackBarChart?.tooltip"
                [fill]="stackBarChart?.fill"
                [legend]="stackBarChart?.legend"
              ></apx-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
